
import wx from 'weixin-js-sdk'
import setting from '../../../server/settings'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Clocker from 'vux/src/components/clocker/index.vue'

const settings = require('../../../server/settings')
import api from '~api'
export default {
name: "onlinefee",
components: {
XHeader,Group,Selector,XInput,Toast,Actionsheet,Clocker
},
computed:{
},
data() {
return {
title: "在线缴费",
feeYear:new Date().getFullYear(),
detail:{}
}
},
mounted(){
this.detail = this.$route.params.detail


},
methods:{
backHome(){
this.$router.push({name:'recharge'})
},
gotopay() {
var _this = this;
var obj = {
"channelPayWay":"JSAPI",

"amount":parseFloat(_this.detail.charge)*100+"",
"terminalCode":"TM20190614112332",
"device":"WEB",
"extra":
"{\"subOpenId\":\""+window.localStorage.getItem("openId")+"\"}",
"subject": _this.feeYear+ _this.detail.chargeItemsName,
"body":_this.feeYear+_this.detail.chargeItemsName,
"stuCode":window.localStorage.getItem("stuCode"),
"collection":"西京学院",
"majorId":window.localStorage.getItem("majorId"),
'orderType':"3",
'regItemId':_this.detail.regItemId,
"year": new Date().getFullYear()+"",
};

_this.$vux.loading.show({
text: 'Loading'
})

_this.$http.post(settings.api_root+"/payment/pay",obj).then(res =>{
_this.$vux.loading.hide();
if(res.data!=null){
var params = {
"timeStamp": res.data.results.payParams.timeStamp,
"package": res.data.results.payParams.package,
"appId": settings.appid,
"signType": res.data.results.payParams.signType,
"nonceStr": res.data.results.payParams.nonceStr
};
var sign = _this.sortParam(params)+"key=wyyzxml88888mtdbq66666GoodSystem";
sign = _this.$md5(sign).toUpperCase();
WeixinJSBridge.invoke(
'getBrandWCPayRequest', {

"appId":settings.appid,     //公众号名称，由商户传入
"timeStamp": res.data.results.payParams.timeStamp,        //时间戳，自1970年以来的秒数
"nonceStr": res.data.results.payParams.nonceStr, //随机串
"package": res.data.results.payParams.package,
"signType": res.data.results.payParams.signType,       //微信签名方式：
"paySign":sign //微信签名
},
function(res){
if(res.err_msg == "get_brand_wcpay_request:ok" ){

_this.$msgbox('温馨提示：', "缴费成功！");
_this.$vux.loading.hide();
_this.$router.push({name: 'home'});
}
if(res.err_msg == "get_brand_wcpay_request:cancel" ){

_this.$msgbox('温馨提示：', "取消支付，缴费失败！");
_this.$vux.loading.hide();
}
if(res.err_msg == "get_brand_wcpay_request:fail" ){

_this.$msgbox('温馨提示：', "缴费失败，请刷新后重试！");
_this.$vux.loading.hide();
}

});
}
})
},
sortParam(obj){
var paramArr = [];
for(var o in obj){
paramArr.push(o +"="+ obj[o] +"&");
}
paramArr.sort();
var str = paramArr.join(":::").replace(/:::/g, "");
return str
},

}
}



// WEBPACK FOOTER //
// ./src/components/newstu/rechargePay.vue